const IP_REGEX = /^(\d{1,3}\.){3}\d{1,3}$/;
const EMAIL_REGEX =/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const isValidOctet = (s) => {
    if (s.length > 1 && s[0] === '0') return false;
    const n = parseInt(s, 10);
    return n >= 0 && n <= 255;
};

export const isValidIpAddress = (ip) => {
    const trimmed = (ip ?? '').trim();
    return !!trimmed && IP_REGEX.test(trimmed) && trimmed.split('.').every(isValidOctet);
};

export const isValidEmailList = (emailStr) => {
    const emails = (emailStr ?? '').split(';').map(e => e.trim()).filter(Boolean);
    return emails.length > 0 && emails.every(e => EMAIL_REGEX.test(e));
};

export const findInvalidEmail = (emailStr) =>
    (emailStr ?? '').split(';').map(e => e.trim()).filter(Boolean).find(e => !EMAIL_REGEX.test(e)) ?? null;
